import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0dfad7ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createElementVNode("div", null, "操作提示："),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px","font-size":"14px"} }, "平台审核商家发布的商品，当商品审核通过并且处于销售中状态时，商家可以销售该商品"),
  /*#__PURE__*/_createElementVNode("div", { style: {"margin-top":"5px","font-size":"14px"} }, "平台可通过“违规重审”，下架违规商品并标记为审核未通过。")
], -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = ["src"]
const _hoisted_5 = { style: {"margin-left":"60px"} }
const _hoisted_6 = /*#__PURE__*/_createTextVNode("店铺名称：")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("店铺id：")
const _hoisted_8 = ["src"]
const _hoisted_9 = { style: {"margin-left":"60px","position":"absolute"} }
const _hoisted_10 = {
  class: "name",
  style: {"margin-top":"-30px"}
}
const _hoisted_11 = /*#__PURE__*/_createTextVNode("商品名称：")
const _hoisted_12 = { style: {"margin-top":"15px"} }
const _hoisted_13 = { key: 0 }
const _hoisted_14 = { key: 2 }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("价格区间：")
const _hoisted_16 = /*#__PURE__*/_createTextVNode("实际销量：")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("总库存：")
const _hoisted_18 = { key: 3 }
const _hoisted_19 = /*#__PURE__*/_createTextVNode("发布时间：")
const _hoisted_20 = /*#__PURE__*/_createTextVNode("修改时间：")
const _hoisted_21 = { key: 4 }
const _hoisted_22 = /*#__PURE__*/_createTextVNode("审核状态： ")
const _hoisted_23 = /*#__PURE__*/_createTextVNode("待审核")
const _hoisted_24 = /*#__PURE__*/_createTextVNode("审核通过")
const _hoisted_25 = /*#__PURE__*/_createTextVNode("审核拒绝")
const _hoisted_26 = /*#__PURE__*/_createTextVNode("审核备注：")
const _hoisted_27 = { key: 5 }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("设置")
const _hoisted_29 = /*#__PURE__*/_createTextVNode("分销")
const _hoisted_30 = /*#__PURE__*/_createTextVNode("违规重审")
const _hoisted_31 = /*#__PURE__*/_createTextVNode("审核")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_cascader = _resolveComponent("a-cascader")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_a_tag = _resolveComponent("a-tag")!
  const _component_a_table = _resolveComponent("a-table")!
  const _component_a_card = _resolveComponent("a-card")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_modal = _resolveComponent("a-modal")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_a_card, { title: "商品管理" }, {
      default: _withCtx(() => [
        _hoisted_1,
        _createVNode(_component_a_form, {
          layout: "inline",
          form: _ctx.searches
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "商家名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入",
                  value: _ctx.searches.shop_name,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searches.shop_name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "商品名称" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  placeholder: "请输入",
                  value: _ctx.searches.goods_name,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.searches.goods_name) = $event))
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "平台分类" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_cascader, {
                  value: _ctx.platform_cate,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.platform_cate) = $event)),
                  options: _ctx.treeData,
                  placeholder: "请选择"
                }, null, 8, ["value", "options"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, {
                  type: "primary",
                  onClick: _ctx.OnSearch
                }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_a_button, { onClick: _ctx.OnReset }, {
                  default: _withCtx(() => [
                    _hoisted_3
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["form"]),
        _createVNode(_component_a_tabs, {
          activeKey: _ctx.searches.type,
          "onUpdate:activeKey": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.searches.type) = $event)),
          onChange: _ctx.callback,
          style: {"margin-top":"20px"}
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_tab_pane, {
              key: "1",
              tab: "销售中商品"
            }),
            _createVNode(_component_a_tab_pane, {
              key: "2",
              tab: "仓库中商品"
            }),
            _createVNode(_component_a_tab_pane, {
              key: "3",
              tab: "回收站商品"
            }),
            _createVNode(_component_a_tab_pane, {
              key: "4",
              tab: "待审核商品"
            }),
            _createVNode(_component_a_tab_pane, {
              key: "5",
              tab: "审核未通过商品"
            })
          ]),
          _: 1
        }, 8, ["activeKey", "onChange"]),
        _createVNode(_component_a_table, {
          dataSource: _ctx.list,
          columns: _ctx.columns,
          bordered: "",
          pagination: _ctx.pagination,
          onChange: _ctx.handleTableChange,
          style: {"margin-top":"10px"}
        }, {
          bodyCell: _withCtx(({ column, record }) => [
            (column.key === 'shop')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createElementVNode("img", {
                    src: record.shop_logo,
                    style: {"width":"50px","height":"50px","position":"absolute","margin-top":"10px"}
                  }, null, 8, _hoisted_4),
                  _createElementVNode("div", _hoisted_5, [
                    _createElementVNode("div", null, [
                      _hoisted_6,
                      _createElementVNode("span", null, _toDisplayString(record.shop_name), 1)
                    ]),
                    _createElementVNode("div", null, [
                      _hoisted_7,
                      _createElementVNode("span", null, _toDisplayString(record.shop_id), 1)
                    ]),
                    _createVNode(_component_a_tag, { color: "blue" }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(record.shop_type_desc), 1)
                      ]),
                      _: 2
                    }, 1024)
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'goods')
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createElementVNode("img", {
                    src: record.image,
                    style: {"width":"50px","height":"50px","margin-top":"-25px","position":"absolute"}
                  }, null, 8, _hoisted_8),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _hoisted_11,
                      _createElementVNode("span", null, _toDisplayString(record.name), 1)
                    ]),
                    _createElementVNode("div", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(record.cate_name_address, (item, index) => {
                        return (_openBlock(), _createElementBlock("span", { key: index }, [
                          (index>10)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_13, " > "))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(item), 1)
                        ]))
                      }), 128))
                    ])
                  ])
                ], 64))
              : _createCommentVNode("", true),
            (column.key === 'sale')
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _createElementVNode("div", null, [
                    _hoisted_15,
                    _createElementVNode("span", null, _toDisplayString(record.min_price) + "-" + _toDisplayString(record.max_price), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_16,
                    _createElementVNode("span", null, _toDisplayString(record.sales_actual), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_17,
                    _createElementVNode("span", null, _toDisplayString(record.stock), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (column.key === 'update_time')
              ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                  _createElementVNode("div", null, [
                    _hoisted_19,
                    _createElementVNode("span", null, _toDisplayString(record.create_time), 1)
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_20,
                    _createElementVNode("span", null, _toDisplayString(record.update_time), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (column.key === 'tags')
              ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                  _createElementVNode("div", null, [
                    _hoisted_22,
                    _createElementVNode("span", null, [
                      (record.audit_status==0)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 0,
                            color: "blue"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_23
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (record.audit_status==1)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 1,
                            color: "blue"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_24
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (record.audit_status==2)
                        ? (_openBlock(), _createBlock(_component_a_tag, {
                            key: 2,
                            color: "blue"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_25
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _hoisted_26,
                    _createElementVNode("span", null, _toDisplayString(record.audit_remark), 1)
                  ])
                ]))
              : _createCommentVNode("", true),
            (column.key === 'action')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin-left":"10px"},
                    onClick: ($event: any) => (_ctx.setting(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_28
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  _createVNode(_component_a_button, {
                    size: "small",
                    style: {"margin-left":"10px"},
                    onClick: ($event: any) => (_ctx.share(record))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_29
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (_ctx.searches.type == 1)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 0,
                        size: "small",
                        style: {"margin-left":"10px"},
                        onClick: ($event: any) => (_ctx.goodsReAudit(record,2))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (_ctx.searches.type == 4 || _ctx.searches.type == 5)
                    ? (_openBlock(), _createBlock(_component_a_button, {
                        key: 1,
                        size: "small",
                        style: {"margin-left":"10px"},
                        onClick: ($event: any) => (_ctx.goodsReAudit(record,1))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_31
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        }, 8, ["dataSource", "columns", "pagination", "onChange"])
      ]),
      _: 1
    }),
    _createVNode(_component_a_modal, {
      title: _ctx.title,
      visible: _ctx.visible,
      "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
      "ok-text": "通过",
      "cancel-text": "不通过",
      onOk: _cache[6] || (_cache[6] = ($event: any) => (_ctx.handleOk(1))),
      onCancel: _cache[7] || (_cache[7] = ($event: any) => (_ctx.handleOk(2)))
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_textarea, {
          value: _ctx.reason,
          "onUpdate:value": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.reason) = $event)),
          placeholder: "请输入审核意见",
          "auto-size": { minRows: 4, maxRows: 4 }
        }, null, 8, ["value"])
      ]),
      _: 1
    }, 8, ["title", "visible"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.shareVisable,
      "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.shareVisable) = $event)),
      title: "设置分销",
      onOk: _ctx.shareSub
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "分佣百分比" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.ratio,
                  "onUpdate:value": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.ratio) = $event)),
                  placeholder: "分佣百分比"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "排序" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.sort,
                  "onUpdate:value": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.sort) = $event)),
                  placeholder: "排序"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "onOk"]),
    _createVNode(_component_a_modal, {
      visible: _ctx.settingVisable,
      "onUpdate:visible": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.settingVisable) = $event)),
      title: "设置",
      onOk: _ctx.setting_sub
    }, {
      default: _withCtx(() => [
        _createVNode(_component_a_form, {
          "label-col": { span: 4 },
          "wrapper-col": { span: 20 },
          autocomplete: "off"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_a_form_item, { label: "商品栏目" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: _ctx.settingData.select,
                  "onUpdate:value": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.settingData.select) = $event)),
                  mode: "multiple",
                  style: {"width":"100%"},
                  placeholder: "商品栏目"
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.colunData, (item, index) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index,
                        value: item.id
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.name), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "虚拟销量" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.settingData.sales_virtual,
                  "onUpdate:value": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.settingData.sales_virtual) = $event)),
                  placeholder: "排序"
                }, null, 8, ["value"])
              ]),
              _: 1
            }),
            _createVNode(_component_a_form_item, { label: "排序权重" }, {
              default: _withCtx(() => [
                _createVNode(_component_a_input, {
                  value: _ctx.settingData.sort_weight,
                  "onUpdate:value": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.settingData.sort_weight) = $event)),
                  placeholder: "排序"
                }, null, 8, ["value"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["visible", "onOk"])
  ]))
}